import React, { useState, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import List from "@material-ui/core/List";
import SwipeableTextMobileStepper from "./Carousel";
import moment from "moment";
import {
  getGroundingList,
  getHealthCheckDetails,
} from "../../service/api";
import CurrencyFormat from "react-currency-format";
import PassOnVehicle from "../PassOnVehicle";
import ExclusivityPeriod from "./ExclusivityPeriod";
import Loaderpage from "../LoaderPage";
import { Box } from "@material-ui/core";
import Pagination from "../../components/PaginationGroundedPage";

export default function GroundingPage(props) {
  const [vehicleResponse, setVehicleResponse] = useState([]);
  const [allVehicleResponse, setAllVehicleResponse] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [passVin, setPassVin] = React.useState("");
  const [dealerName, setDealerName] = React.useState("");
  const [groundingID, setGroundingID] = React.useState("");
  const [loader, setLoader] = React.useState(true);
  useEffect(() => {
      setLoader(true);
      getVehicleDetails(1);
     // getHealthCheckDetail();
  }, [props.selectedDealersData , localStorage.getItem("tenantId")]);
  
  async function getHealthCheckDetail() {
    const healthCheckResponse = await getHealthCheckDetails();
    if(healthCheckResponse)
    console.log("healthCheck api call successfull");
  }
  async function getVehicleDetails(index) {
    const groundedListResponse = await getGroundingList(index);
    setVehicleResponse(groundedListResponse?.data);
    setAllVehicleResponse(groundedListResponse?.data);
    // groundedListResponse?.data ;
     setLoader(false);
  }

  useEffect(() => {
    if (props.selectedDealersData && props.selectedDealersData?.length !== 0 && allVehicleResponse?.length !== 0) {
      let filterbydealer = [];
      props?.selectedDealersData?.forEach((dealer) => {
        allVehicleResponse?.forEach((vehicle) => {

          if (dealer?.dealer_number === vehicle?.dealer_number) {
            filterbydealer.push(vehicle);
          }
        });
      });
      setVehicleResponse(filterbydealer);
    } else {
      setVehicleResponse(allVehicleResponse);
    }
  }, [props.selectedDealersData]);
  const openConditionReport = (VINumber, GroundingEarlyTerm, vehicle) => {
    props.history.push("/conditionreport", {
      vin: VINumber,
      grounding_early_term:GroundingEarlyTerm,
      purchaseSection: true,
      vehicleDetails: vehicle,
    });
  };
  const openConditionScreen = (VINumber, GroundingEarlyTerm, vehicle) => {
    props.history.push("/conditionreport", {
      vin: VINumber,
      grounding_early_term:GroundingEarlyTerm,
      purchaseSection: true,
      vehicleDetails: vehicle,
    });
  };
  const onChangePage = (data, index) => {
    // console.log("data", data);
    getVehicleDetails(index);
  };
  
  const handleOpen = (vin, groundingId, dealer_name) => {
    setPassVin(vin);
    setGroundingID(groundingId);
    setDealerName(dealer_name);
    setOpen(!open);
  };
  const handleClose = () => {
    setOpen(!open);
  };
  React.useEffect(() => {
    const timer = setInterval(() => {
    }, 1000);
    return () => {
      clearInterval(timer);
    };
  }, []);
  
  const milesFormatter = new Intl.NumberFormat('en-US');
  
  return (
    
    <>
      {vehicleResponse && vehicleResponse?.length > 0 ? (
        <div>
        {
        vehicleResponse.map((vehicle, index) => {
          let imageSrc;
          const brand = vehicle?.brand;
          if(brand !=  null){
            switch(brand.toLowerCase()){
              case "toyota":
                imageSrc = "inspection_pending_tfs.png";
                break;
              case "lexus":
                imageSrc = "inspection_pending_lfs.png";
                break;
              case "mazda":
                imageSrc = "inspection_pending_mfs.png";
                break;
            }
          }
            else{
              const tenantId = localStorage.getItem("tenantId");
              if(tenantId !=  null){
                switch(tenantId.toLowerCase()){
                  case "t001":
                    imageSrc = "inspection_pending_tfs.png";
                    break;
                  case "t002":
                    imageSrc = "inspection_pending_mfs.png";
                    break;
                }
            }
          }
          if (!imageSrc) {
            imageSrc = "inspection_pending_tfs.png";
          }

          return (
            <div className="listingPageCard" key={index}>
              <Grid container spacing={3}>
                <Grid item xs={4}>
                  {vehicle?.inspection_mileage !== null ? (
                    <SwipeableTextMobileStepper
                      images={vehicle?.groundingImage}
                    />
                  ) : (
                    <div className="pendingImgBlock">
                      <img
                        className="pendingImg"
                        src={imageSrc}
                        alt="pending"
                      />
                    </div>
                  )}
                </Grid>
                <Grid item xs={4}>
                  <div className="Year-Make-Model-Col">
                    <div className="vehicleMakeModel">
                      <span>
                        {vehicle.model_year} {vehicle.brand} {vehicle.model}{" "}
                        {vehicle.ext_color}{" "}
                      </span>
                    </div>
                    <List>
                      {(vehicle?.account_type?.toLowerCase() === "lease" && vehicle?.vehicle_price) ? (
                            <ExclusivityPeriod vehicle={vehicle} />
                          ) : (vehicle?.account_type?.toLowerCase() === "company car") ? (
                            <ExclusivityPeriod vehicle={vehicle} />
                          ) : (
                            ""
                      )}

                      <span className="textStyle">
                        <span className="textBold"> VIN:</span>
                        <button style={{cursor:'pointer' ,border:'none',background:'none'}}
                          className="vin"
                          onClick={openConditionScreen.bind(
                            this,
                            vehicle.vin,
                            vehicle.grounding_early_term,
                            vehicle
                          )}
                        >
                          {" "}
                          &nbsp;
                          {vehicle.vin}
                        </button>
                      </span>

                      <span className="textStyle">
                        <span className="textBold"> Grounding Date:</span>{" "}
                        {moment(vehicle.grounding_date).format("MM/DD/YYYY")}
                      </span>
                      <span className="textStyle">
                        <span className="textBold"> Grounding Mileage:</span>{" "}
                        {vehicle?.odometer_reading && `${milesFormatter.format(vehicle?.adjMileage ? vehicle?.adjMileage : vehicle?.odometer_reading)} MI`}
                      </span>
                      <span className="textStyle">
                        <span className="textBold"> Inspection Mileage:</span>{" "}
                        {vehicle.inspection_status === "Inspection Complete" && vehicle.inspection_mileage !== null ?
                         vehicle?.inspection_mileage && `${milesFormatter.format(vehicle.inspection_mileage)} MI`
                        : (
                          "Pending"
                        )}
                      </span>
                      <span className="textStyle">
                        <span className="textBold"> Account Type: </span>{" "}
                        {vehicle.account_type}
                      </span>
                    </List>
                  </div>
                </Grid>
                <Grid item xs={4}>
                  <div className="grounding-Vehicle-Price-Option">
                    <div className="vehicleMakeModel1">
                      <span>Vehicle Price Options </span>
                    </div>
                    <div className="vehicalPriceOptions">
                      <div className="vehiclepriceopt">
                        <span className="textStyle">
                          <span className="textBold"> Payoff </span>
                        </span>
                        <span className="textSize">
                          {vehicle?.pay_off_amt && vehicle.grounding_early_term!=="Y" ? 
                          <CurrencyFormat
                            value={parseFloat(vehicle?.pay_off_amt).toFixed(2)}
                            displayType={"text"}
                            thousandSeparator={true}
                            prefix={"$"}
                          /> : 
                          vehicle.grounding_early_term==="Y" ?"NA":
                          vehicle.pay_off_amt===null ? "NA" : "$0.00 " 
                          }
                        </span>
                      </div>
                      <div className="vehiclepriceopt">
                        <span className="textStyle">
                          <span className="textBold">
                            {" "}
                            Residual + Remaining Payments{" "}
                          </span>
                        </span>
                        <span className="textSize">
                          { vehicle?.residual_amt>=0 && vehicle?.residual_amt!==null && vehicle.grounding_early_term!=="Y" ? <CurrencyFormat
                            value={vehicle?.remaining_pmts > 0 ? parseFloat(
                              vehicle.residual_amt + vehicle.remaining_pmts
                            ).toFixed(2) : parseFloat(vehicle.residual_amt).toFixed(2)}
                            displayType={"text"}
                            thousandSeparator={true}
                            prefix={"$"}
                          /> : 
                          vehicle.grounding_early_term==="Y" ?"NA":
                          vehicle.residual_amt===null ? "NA" : "$0.00 " 
                          
                        }
                        </span>
                      </div>
                      <div className="vehiclepriceopt">
                        <span className="textStyle">
                          <span className="textBold"> Market </span>
                        </span>
                        <span className="textSize">
                          {vehicle?.vehicle_price ? (
                            <CurrencyFormat
                              value={parseFloat(vehicle?.vehicle_price).toFixed(2)}
                              displayType={"text"}
                              thousandSeparator={true}
                              prefix={"$"}
                            />
                          ) : 
                          (
                            vehicle.vehicle_price===null ? "Pending" : "$0.00 "
                          )}
                        </span>
                      </div>
                      <div className="vehiclepriceopt">
                        <span className="textStyle">
                          <span className="textBold">
                            {" "}
                            Market + Remaining Payments {" "}
                          </span>
                        </span>
                        <span className="textSize">
                          {vehicle?.vehicle_price>=0 && vehicle.vehicle_price!==null ?(<CurrencyFormat
                            value={vehicle.remaining_pmts > 0 ? parseFloat(
                              vehicle.vehicle_price + vehicle.remaining_pmts
                            ).toFixed(2) : parseFloat(vehicle.vehicle_price).toFixed(2)}
                            displayType={"text"}
                            thousandSeparator={true}
                            prefix={"$"}
                          />):
                          (
                            vehicle.vehicle_price===null ? "Pending" : "$0.00 " 
                            )}
                        </span>
                      </div>
                    </div>

                    <div className="NavigatorButtons">
                      <Button
                        className="PassonVehicleStyle"
                        disabled
                        onClick={handleOpen.bind(
                          this,
                          vehicle.vin,
                          vehicle.groundingId,
                          vehicle.dealer_name
                        )}
                      >
                        Pass on vehicle
                      </Button>
                      <Button
                        variant="contained"
                        color="primary"
                        className="button"
                        onClick={openConditionReport.bind(
                          this,
                          vehicle.vin,
                          vehicle.grounding_early_term,
                          vehicle
                        )}
                      >
                        {"Purchase Vehicle"}
                      </Button>
                    </div>
                  </div>
                </Grid>
              </Grid>
            </div>
          );
        })

      }
        
        {vehicleResponse?.length !== 0 ? (
          <Pagination
            showItemsPerPage={20}
            data={vehicleResponse}
            onChangePage={onChangePage}
          />
        ) : null}
        </div>
      ) : (
        <div>
          {loader && (
            <Box
              height={"90vh"}
              display={"flex"}
              justifyContent={"center"}
              alignItems={"center"}
            >
              <div>
                <Loaderpage />
                <span className="loaderText">Loading...</span>
              </div>
            </Box>
          ) 
          }
          {!loader && (vehicleResponse?.length === 0 || vehicleResponse === undefined) && (
            <div className="listingPageCardNoData">
                <img alt="grounded" src="noDataFound.jpeg" className="nodataImage" />
                <span className="nodataText">No Vehicles found</span>
            </div>
          )}
        </div>
      )}
      <PassOnVehicle
        open={open}
        close={handleClose}
        vin={passVin}
        dealerName={dealerName}
        groundingId={groundingID}
        reload={() => {
          getVehicleDetails(1);
          props.fireEvents();
        }}
      />
    </>
  );
}
